// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2KpEu","footer":"Form_footer__2L3U8"};